function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1925",
    style: {
      fill: "#ffba20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.552244,256.91736 c 0.93345,0 1.84503,0.091 2.72945,0.25964 3.1877,-8.17139 8.03098,-21.2418 8.03098,-25.2289 0,-5.94254 -4.81788,-10.75972 -10.76043,-10.75972 -5.94289,0 -10.75972,4.81718 -10.75972,10.75972 0,3.9871 4.84258,17.05751 8.03028,25.22891 0.88442,-0.16863 1.79635,-0.25965 2.72944,-0.25965"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1927",
    style: {
      fill: "#ffba20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.569054,255.06351 c 0.66005,-0.66004 1.36949,-1.24001 2.11385,-1.74589 -3.52461,-8.03311 -9.34191,-20.69889 -12.16131,-23.51864 -4.20158,-4.20229 -11.014428,-4.20229 -15.216364,3.5e-4 -4.202289,4.20229 -4.202289,11.01443 -3.53e-4,15.21672 2.819047,2.8194 15.485537,8.63741 23.517927,12.16096 0.50659,-0.74401 1.08656,-1.45345 1.74625,-2.1135"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1929",
    style: {
      fill: "#ffba20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.563164,254.44756 c 0,-0.93309 0.0917,-1.84503 0.25964,-2.72909 -8.17174,-3.1877 -21.241805,-8.03063 -25.228546,-8.03063 -5.9425419,0 -10.7600749,4.81718 -10.7597219,10.75972 0,5.9429 4.81718,10.76008 10.7597219,10.76008 3.986741,0 17.056806,-4.84293 25.228546,-8.03063 -0.16792,-0.88442 -0.25964,-1.79635 -0.25964,-2.72945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1931",
    style: {
      fill: "#ffba20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.709314,255.43111 c -0.65969,-0.6597 -1.24001,-1.36949 -1.74589,-2.11349 -8.0324,3.52389 -20.699241,9.3412 -23.517935,12.1606 -4.2022889,4.20197 -4.2022889,11.01404 0,15.21707 4.201936,4.20162 11.014425,4.2019 15.217065,0 2.8187,-2.81947 8.63636,-15.48624 12.16025,-23.51828 -0.74401,-0.50659 -1.45309,-1.08621 -2.11349,-1.7459"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1933",
    style: {
      fill: "#ffba20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.093724,257.43665 c -0.93275,2.6e-4 -1.84503,-0.0917 -2.72909,-0.25965 -3.18841,8.1714 -8.03064,21.24174 -8.03064,25.22884 0,5.94264 4.81683,10.75944 10.76043,10.75944 5.94184,0 10.75972,-4.8168 10.75972,-10.75944 0,-3.9871 -4.84328,-17.05744 -8.03134,-25.22883 -0.88406,0.16792 -1.79563,0.25964 -2.72908,0.25964"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1935",
    style: {
      fill: "#ffba20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.076914,259.2905 c -0.65934,0.66004 -1.36949,1.24001 -2.11385,1.74589 3.52425,8.03311 9.34191,20.69889 12.16096,23.51793 4.20264,4.20303 11.01478,4.20303 15.21707,0 4.20158,-4.20162 4.20229,-11.01411 0,-15.21671 -2.8194,-2.81905 -15.48554,-8.63706 -23.51829,-12.1606 -0.50588,0.744 -1.08585,1.45344 -1.74589,2.11349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1937",
    style: {
      fill: "#ffba20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 40.082804,259.90645 c 2.7e-4,0.93274 -0.0914,1.84502 -0.26,2.72908 8.17175,3.1877 21.24216,8.03064 25.22855,8.03064 5.94325,0 10.76043,-4.81718 10.76043,-10.76008 0,-5.94218 -4.81718,-10.76007 -10.76043,-10.76007 -3.98674,0 -17.0568,4.84329 -25.22855,8.03099 0.16863,0.88441 0.26,1.79563 0.26,2.72944"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1939",
    style: {
      fill: "#ffba20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.936654,258.9229 c 0.65969,0.65934 1.23966,1.36948 1.74625,2.11349 8.03169,-3.52389 20.69888,-9.3412 23.51758,-12.1606 4.20264,-4.20194 4.20264,-11.01407 0,-15.21707 -4.20124,-4.20158 -11.01443,-4.20193 -15.21707,0 -2.8187,2.8194 -8.63636,15.48589 -12.16061,23.51829 0.74437,0.50623 1.4538,1.0862 2.11385,1.74589"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1941",
    style: {
      fill: "#c95362",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.624214,250.92261 c -2.03799,-4.57483 -4.56212,-10.03512 -6.82448,-14.33266 1.27564,-1.84326 3.40465,-3.05082 5.81589,-3.05082 3.34363,0 6.14468,2.32128 6.87917,5.44019 -1.85702,3.38772 -3.96593,7.78474 -5.87058,11.94329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1943",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.655844,253.05374 c -2.20769,-4.95582 -5.28109,-11.48539 -7.01957,-13.56572 0.16933,-1.06398 0.57573,-2.04858 1.16346,-2.89807 2.26236,4.29754 4.78649,9.75783 6.82448,14.33266 -0.32984,0.71966 -0.65334,1.43227 -0.96837,2.13113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1945",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.662894,253.06891 c -0.002,-0.005 -0.005,-0.0102 -0.007,-0.0152 0.31503,-0.69886 0.63853,-1.41147 0.96838,-2.13114 1.90465,-4.15854 4.01355,-8.55556 5.87057,-11.94329 0.12312,0.52211 0.18839,1.0668 0.18839,1.62666 0,0.11959 -0.007,0.25153 -0.0198,0.39511 -0.29845,0.21661 -0.5842,0.45967 -0.85338,0.72884 -1.41569,1.41605 -3.9825,6.61282 -6.14715,11.33898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1947",
    style: {
      fill: "#c95362",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.421094,250.78926 c -4.68383,-1.7974 -10.34838,-3.88126 -15.00046,-5.32483 -0.40111,-2.20521 0.25047,-4.56424 1.95545,-6.26957 1.38006,-1.38042 3.1884,-2.07045 4.99745,-2.07045 1.80834,0 3.61738,0.69039 4.99709,2.0701 0.0847,0.0847 0.17322,0.18274 0.26565,0.29351 -0.0579,0.36407 -0.0878,0.73766 -0.0878,1.11795 0,1.7071 1.35149,5.9496 2.87266,10.18329"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1949",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.219084,252.97119 c -5.06695,-1.94416 -11.86886,-4.39244 -14.57184,-4.63444 -0.63253,-0.87207 -1.0414,-1.85562 -1.22661,-2.87232 4.65208,1.44357 10.31663,3.52743 15.00046,5.32483 0.26282,0.73201 0.53093,1.46367 0.79799,2.18193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1951",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822804,257.17701 v 0 0 c -0.11006,-0.58068 -0.17039,-1.18005 -0.17039,-1.79247 -2.6e-4,-0.61277 0.0603,-1.21214 0.17039,-1.79246 -0.0755,-0.0296 -0.15169,-0.0593 -0.2286,-0.0893 0.0402,-0.60536 0.11783,-1.20085 0.2286,-1.78435 -0.76164,-0.29704 -1.56633,-0.60889 -2.40171,-0.92921 -1.52117,-4.23369 -2.87267,-8.47619 -2.87267,-10.18329 0,-0.38029 0.03,-0.75388 0.0878,-1.11795 1.73849,2.08033 4.81189,8.6099 7.01958,13.56572 -0.65476,1.45274 -1.27283,2.84656 -1.83304,4.12326 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1953",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.594204,253.50282 c -0.43991,-0.17109 -0.89993,-0.34925 -1.37512,-0.53163 -0.26706,-0.71826 -0.53517,-1.44992 -0.79799,-2.18193 0.83538,0.32032 1.64007,0.63217 2.40171,0.92921 -0.11077,0.5835 -0.18838,1.17899 -0.2286,1.78435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1955",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822804,257.17701 v 0 0 0 0 c 0.56022,-1.27671 1.17828,-2.67053 1.83304,-4.12327 0.002,0.005 0.005,0.0102 0.007,0.0152 -0.66675,1.45521 -1.29505,2.86597 -1.84009,4.1081 v 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1957",
    style: {
      fill: "#c95362",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.235402,261.20008 c -1.842911,-1.27529 -3.050469,-3.4043 -3.050469,-5.81519 -3.44e-4,-3.90383 3.163711,-7.06755 7.067551,-7.06755 0.11959,0 0.25118,0.006 0.39476,0.0194 0.2166,0.29845 0.45967,0.58384 0.72848,0.85266 1.20721,1.2072 5.16291,3.2512 9.23185,5.16925 -4.58224,2.04047 -10.06229,4.57306 -14.372172,6.84142"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1959",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 22.134174,262.3639 c -1.063975,-0.16934 -2.04893,-0.57574 -2.898772,-1.16382 4.309882,-2.26836 9.789932,-4.80095 14.372172,-6.84142 0.70379,0.33161 1.4104,0.65935 2.10749,0.97861 -4.95759,2.20804 -11.49844,5.28637 -13.58089,7.02663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1961",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822804,257.17701 v 0 c -0.48859,-0.33268 -0.95426,-0.71332 -1.38818,-1.14689 -0.43356,-0.43321 -0.81456,-0.89958 -1.14653,-1.38818 -0.0744,0.0328 -0.14922,0.0656 -0.22471,0.0988 -0.40005,-0.45649 -0.76624,-0.93239 -1.09996,-1.4231 -0.7493,0.32843 -1.53776,0.67662 -2.35585,1.04104 -4.06894,-1.91805 -8.02464,-3.96204 -9.23185,-5.16925 -0.26881,-0.26882 -0.51188,-0.55421 -0.72848,-0.85266 2.70298,0.242 9.50489,2.69028 14.57184,4.63444 0.55774,1.50036 1.11089,2.94217 1.60372,4.20582 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1963",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.715064,255.33727 c -0.69709,-0.31926 -1.4037,-0.647 -2.10749,-0.97861 0.81809,-0.36442 1.60655,-0.71261 2.35585,-1.04104 0.33372,0.49071 0.69991,0.96661 1.09996,1.4231 -0.43216,0.19015 -0.88336,0.38947 -1.34832,0.59655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1965",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822804,257.17701 c -0.16792,-0.88442 -0.25964,-1.79635 -0.25964,-2.72945 0,-0.3175 0.0106,-0.63253 0.031,-0.94474 0.0769,0.03 0.15311,0.0596 0.2286,0.0893 -0.11007,0.58032 -0.17074,1.17969 -0.17039,1.79246 0,0.61242 0.0603,1.21179 0.17039,1.79246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1967",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822804,257.17701 c -0.49283,-1.26365 -1.04598,-2.70546 -1.60372,-4.20582 0.47519,0.18238 0.93521,0.36054 1.37512,0.53163 -0.0204,0.31221 -0.031,0.62724 -0.031,0.94474 0,0.9331 0.0917,1.84503 0.25965,2.72945 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1969",
    style: {
      fill: "#c95362",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.838474,274.69376 c -1.8087,0 -3.61739,-0.68968 -4.99745,-2.06968 -2.760138,-2.76048 -2.760138,-7.23476 0,-9.99454 0.0843,-0.0847 0.18273,-0.17322 0.29315,-0.26564 0.36407,0.0579 0.73766,0.0878 1.11831,0.0878 1.70674,0 5.94889,-1.35149 10.18222,-2.87267 -1.7974,4.68312 -3.88126,10.34835 -5.32412,15.00004 -0.42051,0.0766 -0.84631,0.11465 -1.27211,0.11465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1971",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.110584,274.57911 c 1.44286,-4.65169 3.52672,-10.31692 5.32412,-15.00004 0.73202,-0.26282 1.46403,-0.53093 2.18264,-0.79799 -1.94381,5.06625 -4.39208,11.86815 -4.63444,14.57117 -0.87172,0.63282 -1.85597,1.04165 -2.87232,1.22686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1973",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.252484,262.45174 c -0.38065,0 -0.75424,-0.03 -1.11831,-0.0878 2.08245,-1.74026 8.6233,-4.81859 13.58089,-7.02663 1.45521,0.6664 2.86597,1.29469 4.10774,1.83973 v 0 0 c -0.58067,0.11007 -1.17898,0.1704 -1.79246,0.1704 -0.002,0 -0.004,0 -0.005,0 -0.61101,0 -1.20791,-0.0603 -1.78717,-0.1704 -0.0293,0.0755 -0.0589,0.1517 -0.0889,0.2286 -0.60572,-0.0399 -1.20121,-0.11782 -1.78435,-0.2286 -0.29739,0.762 -0.6089,1.56634 -0.92993,2.40207 -4.23333,1.52118 -8.47548,2.87267 -10.18222,2.87267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1975",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.434704,259.57907 c 0.32103,-0.83573 0.63253,-1.64007 0.92993,-2.40206 0.58314,0.11077 1.17863,0.18873 1.78435,0.22859 -0.17145,0.43992 -0.34925,0.89994 -0.53164,1.37548 -0.71861,0.26706 -1.45062,0.53517 -2.18264,0.79799 m 6.3881,-2.40207 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1977",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822804,257.17701 c -0.74401,-0.50659 -1.45309,-1.08621 -2.11349,-1.7459 -0.22437,-0.22472 -0.43991,-0.45473 -0.64593,-0.69039 0.0755,-0.0332 0.15028,-0.066 0.22471,-0.0988 0.33197,0.4886 0.71297,0.95497 1.14653,1.38818 0.43392,0.43357 0.89959,0.81421 1.38818,1.14689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1979",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822804,257.17701 c -1.24177,-0.54505 -2.65253,-1.17334 -4.10774,-1.83974 0.46496,-0.20708 0.91616,-0.4064 1.34832,-0.59655 0.20602,0.23566 0.42156,0.46567 0.64593,0.69039 0.6604,0.65969 1.36948,1.23931 2.11349,1.7459 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1981",
    style: {
      fill: "#c95362",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 38.030694,280.81488 c -3.90384,0 -7.0672,-3.1641 -7.0672,-7.06685 0,-0.12005 0.007,-0.25191 0.0194,-0.39578 0.29845,-0.21636 0.58385,-0.45942 0.85302,-0.72817 1.20685,-1.20727 3.25049,-5.16255 5.16855,-9.23148 2.04082,4.58258 4.57306,10.06192 6.84177,14.3717 -1.27564,1.84302 -3.40466,3.05058 -5.81554,3.05058"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1983",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.846234,277.7643 c -2.26871,-4.30978 -4.80095,-9.78912 -6.84177,-14.3717 0.33161,-0.70379 0.6597,-1.41112 0.97896,-2.10785 2.20804,4.95758 5.28637,11.49907 7.02663,13.58127 -0.16898,1.06398 -0.57573,2.04848 -1.16382,2.89828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1985",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 30.982904,273.35225 c 0.24236,-2.70302 2.69063,-9.50492 4.63444,-14.57117 1.50036,-0.55774 2.94217,-1.11125 4.20546,-1.60407 v 0 0 c -0.33196,0.48859 -0.71296,0.95461 -1.14652,1.38817 -0.43321,0.43357 -0.89924,0.81422 -1.38819,1.14689 0.0325,0.0741 0.0656,0.14922 0.0988,0.22471 -0.45649,0.40005 -0.93274,0.76589 -1.42381,1.09961 0.32879,0.7493 0.67698,1.53812 1.0414,2.35621 -1.91805,4.06893 -3.96169,8.02421 -5.16854,9.23148 -0.26918,0.26875 -0.55457,0.51181 -0.85302,0.72817"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1987",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.004464,263.3926 c -0.36442,-0.81809 -0.71261,-1.60691 -1.0414,-2.35621 0.49107,-0.33372 0.96732,-0.69956 1.42381,-1.09961 0.1898,0.43216 0.38912,0.88301 0.59655,1.34797 -0.31926,0.69673 -0.64735,1.40406 -0.97896,2.10785 m 2.81834,-6.21559 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1989",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.089484,257.43665 c -0.31609,0 -0.62971,-0.0106 -0.9405,-0.031 0.03,-0.0769 0.0596,-0.1531 0.0889,-0.2286 0.57926,0.11007 1.17616,0.1704 1.78717,0.1704 0.002,0 0.004,0 0.005,0 0.61348,0 1.21179,-0.0603 1.79246,-0.1704 -0.88406,0.16793 -1.79564,0.25965 -2.72909,0.25965 -10e-4,0 -0.003,0 -0.004,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1991",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.617344,258.78108 c 0.18239,-0.47554 0.36019,-0.93556 0.53164,-1.37548 0.31079,0.0205 0.62441,0.031 0.9405,0.031 10e-4,0 0.003,0 0.004,0 0.93345,0 1.84503,-0.0917 2.72909,-0.25964 v 0 c -1.2633,0.49282 -2.7051,1.04633 -4.20546,1.60407"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1993",
    style: {
      fill: "#c95362",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.272434,277.22949 c -1.80834,0 -3.61703,-0.69024 -4.99709,-2.07035 -0.0843,-0.0848 -0.17286,-0.18245 -0.26529,-0.29312 0.0579,-0.36406 0.0878,-0.73766 0.0878,-1.11799 0,-1.70712 -1.35149,-5.94959 -2.87267,-10.18328 4.68312,1.7974 10.34874,3.88162 15.00011,5.32483 0.40146,2.20518 -0.25012,4.56452 -1.95545,6.26956 -1.38006,1.38011 -3.18875,2.07035 -4.99745,2.07035"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1995",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 57.225334,268.88958 c -4.65137,-1.44321 -10.31699,-3.52743 -15.00011,-5.32483 -0.26317,-0.73201 -0.53128,-1.46367 -0.79834,-2.18193 5.06695,1.94416 11.86851,4.39244 14.57149,4.63444 0.63288,0.87207 1.04175,1.85561 1.22696,2.87232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1997",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.010054,274.86602 c -1.74026,-2.0822 -4.81859,-8.62369 -7.02663,-13.58127 0.6664,-1.45521 1.2947,-2.86597 1.83938,-4.10775 v 0 0 0 0 0 0 0 c 0.001,0.007 0.003,0.0141 0.004,0.0215 8e-4,0.004 10e-4,0.007 0.002,0.0109 0.10689,0.57044 0.16475,1.15888 0.16475,1.76001 2.7e-4,0.61278 -0.06,1.21215 -0.1711,1.79247 0.0759,0.0296 0.15205,0.0593 0.22896,0.0892 -0.0399,0.60536 -0.11783,1.20085 -0.22896,1.78435 0.76236,0.29704 1.56634,0.60854 2.40242,0.92921 1.52118,4.23369 2.87267,8.47616 2.87267,10.18329 0,0.38033 -0.03,0.75392 -0.0878,1.11799"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1999",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.225224,263.56475 c -0.83608,-0.32067 -1.64006,-0.63218 -2.40242,-0.92922 0.11113,-0.58349 0.18909,-1.17898 0.22896,-1.78435 0.43991,0.1711 0.89993,0.34925 1.37512,0.53164 0.26706,0.71826 0.53517,1.44992 0.79834,2.18193 m -2.39607,-6.35529 c -7.9e-4,-0.004 -0.001,-0.007 -0.002,-0.0109 8e-4,0.004 10e-4,0.007 0.002,0.0109 m -0.006,-0.0325 v 0 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2001",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.386874,259.93678 c -0.0332,-0.0755 -0.0663,-0.15063 -0.0988,-0.22471 0.48895,-0.33267 0.95498,-0.71332 1.38819,-1.14689 0.43356,-0.43356 0.81456,-0.89958 1.14652,-1.38817 -0.50588,0.744 -1.08585,1.45344 -1.74589,2.11349 -0.22437,0.22472 -0.45473,0.43991 -0.69004,0.64628"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2003",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 37.983424,261.28475 c -0.20743,-0.46496 -0.40675,-0.91581 -0.59655,-1.34797 0.23531,-0.20637 0.46567,-0.42156 0.69004,-0.64628 0.66004,-0.66005 1.24001,-1.36949 1.74589,-2.11349 v 0 c -0.54468,1.24177 -1.17298,2.65253 -1.83938,4.10774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2005",
    style: {
      fill: "#c95362",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.393834,266.03667 c -0.11959,0 -0.25188,-0.007 -0.39546,-0.0194 -0.2166,-0.29845 -0.45932,-0.58385 -0.72849,-0.85302 -1.20685,-1.20685 -5.16255,-3.25084 -9.23149,-5.1689 4.58259,-2.04082 10.06158,-4.5727 14.37182,-6.84177 1.84326,1.27529 3.05082,3.40466 3.05082,5.81554 0,3.90384 -3.16406,7.06755 -7.0672,7.06755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2007",
    style: {
      fill: "#24152a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.038394,259.99535 c -0.70379,-0.33162 -1.41075,-0.65934 -2.10749,-0.97861 4.95759,-2.20804 11.49844,-5.28637 13.58089,-7.02663 1.06397,0.16898 2.04893,0.57538 2.89842,1.16346 -4.31024,2.26907 -9.78923,4.80096 -14.37182,6.84178"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2009",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 55.998374,266.01726 c -2.70298,-0.242 -9.50454,-2.69028 -14.57149,-4.63444 -0.55774,-1.50036 -1.11089,-2.94252 -1.60408,-4.20582 0.006,0.004 0.012,0.008 0.018,0.0124 0.003,0.002 0.006,0.004 0.01,0.006 0.47908,0.32808 0.93557,0.70273 1.36102,1.12818 0.43321,0.43286 0.81421,0.89924 1.14653,1.38819 0.0744,-0.0328 0.14922,-0.0656 0.22472,-0.0988 0.40005,0.45649 0.76623,0.93239 1.10031,1.4231 0.7486,-0.32843 1.53811,-0.67698 2.3555,-1.04104 4.06894,1.91805 8.02464,3.96204 9.23149,5.1689 0.26917,0.26917 0.51188,0.55456 0.72848,0.85301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2011",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.682904,261.03639 c -0.33408,-0.49071 -0.70027,-0.96661 -1.10032,-1.4231 0.43216,-0.19015 0.88336,-0.38947 1.34832,-0.59655 0.69674,0.31927 1.4037,0.64699 2.10749,0.97861 -0.81738,0.36406 -1.6069,0.71261 -2.35549,1.04104 m -3.83258,-3.84069 c -0.003,-0.002 -0.006,-0.004 -0.01,-0.006 0.003,0.002 0.006,0.004 0.01,0.006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2013",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 40.051764,260.85118 c -0.0769,-0.03 -0.15311,-0.0596 -0.22896,-0.0892 0.11113,-0.58032 0.17145,-1.17969 0.1711,-1.79246 0,-0.60114 -0.0579,-1.18957 -0.16475,-1.76001 0.1644,0.87418 0.25365,1.77447 0.25365,2.69699 0,0.3175 -0.0106,0.63253 -0.031,0.94473 m -0.22472,-3.65266 c -10e-4,-0.007 -0.003,-0.0145 -0.004,-0.0215 v 0 c 10e-4,0.007 0.003,0.0141 0.004,0.0215"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2015",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 41.426884,261.38282 c -0.47519,-0.18239 -0.93521,-0.36054 -1.37512,-0.53164 0.0204,-0.3122 0.031,-0.62723 0.031,-0.94473 0,-0.92252 -0.0892,-1.82281 -0.25365,-2.69699 -7.9e-4,-0.004 -10e-4,-0.007 -0.002,-0.0109 -0.001,-0.007 -0.003,-0.0145 -0.004,-0.0215 v 0 c 0.49318,1.2633 1.04634,2.70545 1.60408,4.20582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2017",
    style: {
      fill: "#c95362",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.029334,255.57292 c 1.9438,-5.06694 4.39208,-11.8692 4.63409,-14.57183 1.2326,-0.8943 2.68851,-1.34127 4.14443,-1.34127 1.80869,0 3.61738,0.69004 4.99709,2.0701 2.76014,2.76049 2.76014,7.23477 0,9.99455 -0.0847,0.0843 -0.18274,0.17321 -0.29315,0.26564 -0.36442,-0.0579 -0.73766,-0.0878 -1.11796,-0.0878 -2.00236,0 -7.49194,1.85914 -12.3645,3.67065"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2019",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822804,257.17701 v 0 c 0.33303,-0.4886 0.71367,-0.95462 1.14724,-1.38819 0.43356,-0.43356 0.89923,-0.81456 1.38818,-1.14688 -0.21943,-0.49953 -0.45191,-1.02658 -0.69533,-1.57303 2.16465,-4.72617 4.73146,-9.92294 6.14715,-11.33899 0.26918,-0.26917 0.55493,-0.51223 0.85338,-0.72883 -0.24201,2.70263 -2.69029,9.50489 -4.63409,14.57183 -1.50072,0.55775 -2.94252,1.1109 -4.20653,1.60409"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2021",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 39.822804,257.17701 c 0.54504,-1.24214 1.17334,-2.65289 1.84009,-4.1081 0.24342,0.54645 0.4759,1.0735 0.69533,1.57303 -0.48895,0.33232 -0.95462,0.71332 -1.38818,1.14688 -0.43357,0.43357 -0.81421,0.89959 -1.14724,1.38819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2023",
    style: {
      fill: "#181317",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.930904,259.01674 c -1.45521,-0.66675 -2.86597,-1.29505 -4.1081,-1.83973 v 0 c 0.58103,-0.11043 1.17969,-0.17075 1.79282,-0.17075 0.61313,0 1.21215,0.0603 1.79282,0.17075 0.19861,-0.50836 0.40675,-1.04599 0.62089,-1.60409 4.87256,-1.81151 10.36214,-3.67065 12.3645,-3.67065 0.3803,0 0.75354,0.03 1.11796,0.0878 -2.08245,1.74026 -8.6233,4.81859 -13.58089,7.02663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2025",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.408444,257.17701 c -0.58067,-0.11043 -1.17969,-0.17075 -1.79282,-0.17075 -0.61313,0 -1.21179,0.0603 -1.79282,0.17075 v 0 c 1.26401,-0.49319 2.70581,-1.04634 4.20653,-1.60409 -0.21414,0.5581 -0.42228,1.09573 -0.62089,1.60409"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2027",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.357874,259.71207 c -0.33232,-0.48895 -0.71332,-0.95533 -1.14653,-1.38819 -0.42545,-0.42545 -0.88195,-0.8001 -1.36102,-1.12818 0.73413,0.50201 1.4344,1.07562 2.08633,1.7272 0.22472,0.22437 0.43991,0.45473 0.64593,0.69039 -0.0755,0.0332 -0.15028,0.066 -0.22471,0.0988 m -2.51708,-2.52272 c -0.006,-0.004 -0.012,-0.008 -0.018,-0.0124 v 0 0 c 0.006,0.004 0.012,0.008 0.018,0.0124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2029",
    style: {
      fill: "#141212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 42.582584,259.61329 c -0.20602,-0.23566 -0.42121,-0.46602 -0.64593,-0.69039 -0.65193,-0.65158 -1.3522,-1.22519 -2.08633,-1.7272 -0.003,-0.002 -0.006,-0.004 -0.01,-0.006 -0.006,-0.004 -0.012,-0.008 -0.018,-0.0124 v 0 c 1.24213,0.54469 2.65289,1.17299 4.1081,1.83974 -0.46496,0.20708 -0.91617,0.4064 -1.34832,0.59655"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2031",
    style: {
      fill: "#ffcb4c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.437764,256.92512 c 0,5.47652 -4.439,9.91553 -9.91517,9.91553 -5.47617,0 -9.91552,-4.43901 -9.91552,-9.91553 0,-5.47582 4.43935,-9.91517 9.91552,-9.91517 5.47617,0 9.91517,4.43935 9.91517,9.91517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower18);
export default __webpack_public_path__ + "static/media/flower-18.9bca1af3eeb28f91a2df63feb810ffbe.svg";
export { ForwardRef as ReactComponent };